import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/close.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    padding: '24 24',
  },
  title: {
    color: '#3393F3',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  subTitle: {
    color: '#3393F3',
    fontSize: 12,
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    marginBottom: 12,
    '& input': {
      float: 'right',
    },
  },
  typeHead: {
    fontSize: 14,
    color: 'rgba(24, 24, 24, 1)',
    fontWeight: 600,
  },
  typeDetail: {
    fontWeight: 400,
    fontSize: 14,
  },
})

const NotesDataTooltipModal = ({
  open,
  setOpen,
  handleClose,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <div className={classes.content}>
            {!isMobile && (
              <div className={classes.header}>
                <span className={classes.title}>Emmalyn Insights</span>
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}

            {isMobile && (
              <>
                <div className={classes.header} style={{ marginBottom: 5 }}>
                  <span className={classes.title}>EMMALYN INSIGHTS</span>
                  <input
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
              </>
            )}

            <div className={classes.detailContent}>
              <span className={classes.typeDetail}>
                <b>Emmalyn Insights: </b>Quick Note (“QN”) is a textual summary
                compiled using information curated in Emmalyn’s risk-based
                analysis. This analyst-styled note highlights factors deemed
                relevant in describing the risk(s) faced by the company.
              </span>
            </div>
            <div className={classes.detailContent}>
              <span className={classes.typeDetail}>
                <b>Next Best Action: </b>Components contributing to Emmalyn’s
                data insight can be investigated via the User Interface, QN
                acting as a signpost regarding the origin of the detected threat
                i.e. Media, Fundamental, Credit risk, Market, ESG, etc.
              </span>
            </div>
            <div className={classes.detailContent}>
              <span className={classes.typeDetail}>
                <b>Report Download PDF: </b> “Export to PDF” function appears in
                the top right section of the User Interface allowing the risk
                report to be generated and support subsequent workflows.
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(NotesDataTooltipModal)
